// extracted by mini-css-extract-plugin
export var footer = "_rm-0";
export var inherit = "_rm-1";
export var input = "_rm-2";
export var modalContent = "_rm-3";
export var quillEditor = "_rm-4";
export var subtitle = "_rm-5";